import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'

import QueueAnim from 'rc-queue-anim'
import Button from '../../components/common/Button'
import Icon from '../../components/common/Icon'
import InputPassword from '../../components/common/InputPassword'
import * as crypto from '../../utils/cryptoHelper'
import errorIcon from '../../static/images/error-icon.svg'
import zIndex from '../../utils/zIndexScale'

import {
  setNeedAuth as setNeedAuthAction,
  setAccount as setAccountAction,
} from '../../redux/account/action'

const Layer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${zIndex.modal};
  background: rgba(0, 0, 0, 0.5);
`

const Wrapper = styled.div`
  min-width: 320px;
  max-width: 450px;
  padding: 30px;
  box-sizing: border-box;
  background: ${({ theme }) => theme.popupBg};
  box-shadow: ${({ theme }) => theme.boxShadow};
  border-radius: 3px;
  position: fixed;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const Title = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.fontColor};
`

const Content = styled.div`
  padding: 20px 0;
  font-size: 16px;
  margin: 20px 0 30px 0;
  width: 400px;
  @media (min-width: 320px) and (max-width: 623px) {
    width: 280px;
  }
`

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  a {
    color: #f0b90b;
    font-size: 14px;
  }
`

const ErrorMsg = styled.div`
  color: #f23051;
  position: absolute;
  bottom: 80px;
  left: 25px;
  right: 0;
  font-size: 14px;
  display: flex;
  height: 20px;
  align-items: center;
  img {
    width: 15px;
    margin-right: 5px;
  }
`

const Close = styled.div`
  position: absolute;
  top: 5px;
  right: 8px;
  cursor: pointer;
  line-height: 20px;
  color: ${({ theme }) => theme.fontColor};
  &:hover {
    color: #f0b90b;
  }
`

class ConfirmPasswordModalHost extends Component {
  static propTypes = {
    needAuth: PropTypes.bool,
    setAccount: PropTypes.func,
    setNeedAuth: PropTypes.func,
    dispatch: PropTypes.func,
    triggerElement: PropTypes.element,
  }

  static defaultProps = {
    needAuth: false,
    setAccount: () => {},
    setNeedAuth: () => {},
    dispatch: () => {},
    triggerElement: null,
  }

  constructor(props) {
    super(props)
    this.state = {
      password: '',
      errMsg: '',
      loading: false,
    }
  }

  componentDidMount() {
    window.document.body.addEventListener('keydown', this._keydown)
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutHanle1)
    clearTimeout(this.timeoutHanle2)
    window.document.body.removeEventListener('keydown', this._keydown)
  }

  _keydown = evt => {
    if (evt.keyCode === 13) {
      this._confirm()
    }
  }

  _close = () => {
    const { dispatch, setNeedAuth } = this.props
    dispatch(setNeedAuth(false))
  }

  _confirm = () => {
    document.activeElement.blur() // andorid hide keyboard
    const { setAccount } = this.props
    let user = sessionStorage.getItem('user')
    user = (user && JSON.parse(user)) || {}
    if (user.address && user.keystore) {
      const { password } = this.state
      const { dispatch, triggerElement } = this.props
      if (!password) {
        this.setState({ errMsg: 'password should not be null' })
        return
      }

      this.setState({ loading: true })
      this.timeoutHanle1 = setTimeout(() => {
        try {
          const privateKey = crypto.decryptPrivatekey(user.keystore, password, user.address)
          dispatch(setAccount({ privateKey, cipher: password, flags: user.flags }))
          this.timeoutHanle2 = setTimeout(() => {
            this.setState({ loading: false })
            triggerElement && triggerElement.click()
            this._close()
          }, 800)
        } catch (err) {
          console.error('Wrong Password!', err)
          this.setState({ errMsg: 'Wrong Password!', loading: false })
        }
      }, 100)
    }
  }

  _passwordChange = password => {
    this.setState({ password })
  }

  render() {
    const { needAuth } = this.props
    const { errMsg, loading } = this.state
    if (!needAuth) return null
    return (
      <QueueAnim
        animConfig={[
          {
            opacity: [1, 0],
          },
        ]}
      >
        <Layer key="1">
          <QueueAnim leaveReverse={true} delay={100} type={['top', 'bottom']}>
            <Wrapper key="2">
              <Title>Password</Title>
              <Content>
                <InputPassword
                  withRules={false}
                  autoFocus={true}
                  onChange={this._passwordChange}
                  title="Enter your session password"
                />
              </Content>
              <Footer>
                <Button onClick={this._confirm} loading={loading} width="100px" type="submit">
                  <span>Confirm</span>
                </Button>
              </Footer>
              {errMsg && (
                <ErrorMsg>
                  <img src={errorIcon} alt={true} />
                  <span>{errMsg}</span>
                </ErrorMsg>
              )}
              <Close onClick={this._close}>
                <Icon type="close" size="18" />
              </Close>
            </Wrapper>
          </QueueAnim>
        </Layer>
      </QueueAnim>
    )
  }
}

const mapStateToProps = ({
  account: { privateKey, needAuth },
  globalData: { triggerElement },
}) => ({
  needAuth,
  privateKey,
  triggerElement,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setAccount: setAccountAction,
      setNeedAuth: setNeedAuthAction,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmPasswordModalHost)
